export default __webpack_public_path__ + "static/media/swoosh.1099c76c.png";